
import { useState, useMemo } from "react";
import Modal from "../../UiComponents/Modal";
import { formDetails } from "./formDetails";
import { Form, FormAnswer } from "../Form";
import { ModalContainer } from "../../panel/ModalStyles";
import StarRating from '../fromPages/StarRating'
import MultilineAnswer from "../fromPages/MultilineAnswer";
import PillMultiSelect from "../fromPages/PillMultiSelect";



const SatisfactionForm = ({userContext, show, setShow}) => {

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(1);
    const [numberOfStars, setNumberOfStars] = useState(null);
    
    const form = useMemo(() => {
        return new Form(formDetails.form.name, formDetails.form.version, formDetails.form.title, userContext);
    }, [userContext]);

    const closable = useMemo(() => {
        return currentQuestionIndex > 1;
    }, [currentQuestionIndex]);

    const setShowHandler = (value) => {
        if (!closable) return; // prevent before first question is answered
        setShow(value);
    }

    const nextQuestionHandler = (stars) => {
        let numStars; 
        if (stars) {
            numStars = stars;
            setNumberOfStars(stars);
        }
        else numStars = numberOfStars;

        // if first queston and star is lower than 3, skip to elaboration question
        if (numStars < 3 && currentQuestionIndex === 1) setCurrentQuestionIndex(formDetails.questions.find(q => q.questionId === 'SATISFACTION_ELABORATE').questionNumber); // skipt to optional elaboration question if rating is 1-2 stars

        // else if first question and star is 3 or higher, skip to "what do you like" question
        else if (numStars >= 3 && currentQuestionIndex === 1) setCurrentQuestionIndex(formDetails.questions.find(q => q.questionId === 'SATISFACTION_LIKE').questionNumber); // skip to "what do you like" question if rating is 3-4 stars

        // else if questionId is SATISFACTION_ELABORATE, close form
        else if (currentQuestionIndex === formDetails.questions.find(q => q.questionId === 'SATISFACTION_ELABORATE').questionNumber) setShowHandler(false);

        // else if questionId is SATISFACTION_LIKE && star is higher than 4 go to SATISFACTION_RECOMMEND
        else if (currentQuestionIndex === formDetails.questions.find(q => q.questionId === 'SATISFACTION_LIKE').questionNumber && numStars > 4) setCurrentQuestionIndex(formDetails.questions.find(q => q.questionId === 'SATISFACTION_RECOMMEND').questionNumber);
        
        // else if questionId is SATISFACTION_LIKE && star is 3 or 4, skip to "what could be better" question
        else if (currentQuestionIndex === formDetails.questions.find(q => q.questionId === 'SATISFACTION_LIKE').questionNumber && numStars >= 3) setCurrentQuestionIndex(formDetails.questions.find(q => q.questionId === 'SATISFACTION_IMPROVE').questionNumber);

        // else if questionId is SATISFACTION_RECOMMEND, or IMROVE, close form
        else if ((currentQuestionIndex === formDetails.questions.find(q => q.questionId === 'SATISFACTION_RECOMMEND').questionNumber) || (currentQuestionIndex === formDetails.questions.find(q => q.questionId === 'SATISFACTION_IMPROVE').questionNumber)) setShowHandler(false);
    }

    return(
        <Modal show={show} close={() => setShowHandler(false)}>
            <ModalContainer>
                
                {currentQuestionIndex === formDetails.questions.find(q => q.questionId === 'SATISFACTION_STAR').questionNumber && <StarRating form={form} closable={false} questionDetails={formDetails.questions.find(q => q.questionNumber === currentQuestionIndex)} nextQuestion={(stars) => nextQuestionHandler(stars)} />}

                {currentQuestionIndex === formDetails.questions.find(q => q.questionId === 'SATISFACTION_LIKE').questionNumber && <PillMultiSelect form={form} close={() => setShowHandler(false)} totalQuestions={false} currentQuestionNumber={2}
                    questionDetails={formDetails.questions.find(q => q.questionNumber === currentQuestionIndex)} nextQuestion={() => nextQuestionHandler()} />}

                {currentQuestionIndex === formDetails.questions.find(q => q.questionId === 'SATISFACTION_IMPROVE').questionNumber && <MultilineAnswer form={form} close={() => setShowHandler(false)} totalQuestions={false} currentQuestionNumber={3}
                    questionDetails={formDetails.questions.find(q => q.questionNumber === currentQuestionIndex)} nextText={'Done'} isLastQuestion={true} nextQuestion={() => nextQuestionHandler()} placeholder={"Share a quick comment?"} />}

                {currentQuestionIndex === formDetails.questions.find(q => q.questionId === 'SATISFACTION_RECOMMEND').questionNumber && <MultilineAnswer form={form} close={() => setShowHandler(false)} totalQuestions={false} currentQuestionNumber={3}
                    questionDetails={formDetails.questions.find(q => q.questionNumber === currentQuestionIndex)} nextText={'Done'} isLastQuestion={true} nextQuestion={() => nextQuestionHandler()} placeholder={"Friend's phone number or email"}/>}

                {currentQuestionIndex === formDetails.questions.find(q => q.questionId === 'SATISFACTION_ELABORATE').questionNumber && <MultilineAnswer form={form} close={() => setShowHandler(false)} totalQuestions={false} currentQuestionNumber={2}
                    questionDetails={formDetails.questions.find(q => q.questionNumber === currentQuestionIndex)} nextText={'Done'} isLastQuestion={true} nextQuestion={() => nextQuestionHandler()} placeholder={"What's not working?"} />}

            </ModalContainer>
        </Modal>
    )
}

export default SatisfactionForm;